import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import ReCaptcha from 'react-google-recaptcha'
import {Button, Modal, Input} from 'antd'

import style from './whitepaper.sass'

@inject('store') @observer
class Whitepaper extends Component {
  state = {modalHack:false}
  showModal = () => {
    this.setState({modalHack:true})
    this.props.store.public.showWhitepaperModal()
  }
  handleCancel = () => {
    this.props.store.public.hideWhitepaperModal()
  }
  handleOk = () => {
    this.props.store.public.downloadWhitepaper()
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.public.changeCredentials('whitepaper', name, value)
  }
  handleFocus = (e) => {
    this.props.store.public.removeError('whitepaper', e.target.name)
  }
  afterClose = () => {
    this.setState({modalHack:false})
  }
  handleRecaptcha = (value) => {
    this.props.store.public.changeCredentials('whitepaper', 'recaptcha_response', value)
  }

  render() {
    const {modalHack} = this.state
    const {credentials, errors, loading, modal} = this.props.store.public.whitepaper
    return(
      <section className='bg-white'>
        <div className='landing-container' styleName='container'>
          <h2>Learn how to build strategies and trade using alternative data</h2>
          <div styleName='cards-container'>
            <div styleName='card'>
              <h4>Alternative Data and Quantamental Trading Strategies</h4>
              <p>Discover how to combine technical and fundamental analysis with alternative data to build the complete picture.</p>
              <Button type='primary' onClick={this.showModal}>Download</Button>
              {modalHack &&
                <Modal
                  title="Please fill in the following information to continue"
                  visible={modal}
                  onOk={this.handleOk}
                  onCancel={this.handleCancel}
                  confirmLoading={loading}
                  afterClose={this.afterClose}
                >
                  <form styleName='form'>
                    <div>
                      <Input
                        type='text'
                        name='first_name'
                        placeholder='First Name'
                        value={credentials.first_name}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                      />
                      <p styleName='error'>{errors.first_name}</p>
                    </div>
                    <div>
                      <Input
                        type='text'
                        name='last_name'
                        placeholder='Last Name'
                        value={credentials.last_name}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                      />
                      <p styleName='error'>{errors.last_name}</p>
                    </div>
                    <div>
                      <Input
                        type='email'
                        name='email'
                        placeholder='Email'
                        value={credentials.email}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                      />
                      <p styleName='error'>{errors.email}</p>
                    </div>
                    <div>
                      <Input
                        type='text'
                        name='company'
                        placeholder='Company'
                        value={credentials.company}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                      />
                      <p styleName='error'>{errors.company}</p>
                    </div>
                    <div>
                      <Input
                        type='text'
                        name='job_title'
                        placeholder='Job Title'
                        value={credentials.job_title}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                      />
                      <p styleName='error'>{errors.job_title}</p>
                    </div>
                    <div styleName='captcha-wrapper'>
                      <ReCaptcha
                        sitekey='6LeZ7T0UAAAAANszyCDgGufTqBUHqXp6kKYcVtjf'
                        onChange={this.handleRecaptcha}
                      />
                    </div>
                  </form>
                </Modal>
              }
              <span styleName='filesize'>1.0 MB</span>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Whitepaper
